import React from 'react';

/* eslint-disable max-len */
const SexToysIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M26.4514 12.9155C26.8721 11.8314 27.1465 10.6961 27.2674 9.53952C27.3826 8.52832 26.2306 5.58112 25.3474 5.47232C23.7154 5.27072 20.3362 7.41152 19.9458 8.08352C19.1458 9.42752 16.6946 14.0963 9.65456 18.2403C7.55536 19.4755 3.37616 22.3331 4.66256 25.8531C5.94896 29.3731 9.69936 29.8307 13.4402 28.6051C18.2978 27.0051 22.2434 21.0787 23.4946 19.0051C24.2626 17.7475 25.8658 14.7715 26.4066 13.5939",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4514 12.9155C26.8721 11.8314 27.1465 10.6961 27.2674 9.53952C27.3826 8.52832 26.2306 5.58112 25.3474 5.47232C23.7154 5.27072 20.3362 7.41152 19.9458 8.08352C19.1458 9.42752 16.6946 14.0963 9.65456 18.2403C7.55536 19.4755 3.37616 22.3331 4.66256 25.8531C5.94896 29.3731 9.69936 29.8307 13.4402 28.6051C18.2978 27.0051 22.2434 21.0787 23.4946 19.0051C24.2626 17.7475 25.8658 14.7715 26.4066 13.5939",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1603 2.88016C25.8403 2.63696 25.3507 2.82576 25.1075 3.14576C24.9023 3.49307 24.7452 3.86661 24.6403 4.25616C24.4332 4.79074 24.0668 5.24874 23.5907 5.56816C22.8239 5.59117 22.0748 5.80477 21.4111 6.18969C20.7474 6.57461 20.19 7.11874 19.7891 7.77296C19.2532 8.18665 18.6801 8.5498 18.0771 8.85776C18.853 9.3336 19.783 9.49042 20.672 9.29532C21.561 9.10022 22.3399 8.56836 22.8451 7.81136C22.6179 8.23056 22.7555 8.80976 22.9155 9.29296C23.2419 10.2743 23.5694 11.2567 23.8979 12.2402L25.4307 9.33776C25.1282 10.1781 25.1641 11.103 25.5306 11.9174C25.8972 12.7318 26.5659 13.3719 27.3955 13.7026C27.0371 12.2786 27.7155 10.7842 27.5619 9.32496C27.4749 8.60425 27.1853 7.92298 26.7267 7.36016C26.6195 6.88442 26.3786 6.44922 26.0323 6.10576C26.2778 5.35138 26.4146 4.5659 26.4387 3.77296C26.4658 3.61274 26.4547 3.4484 26.4063 3.29328C26.3579 3.13815 26.2737 2.99662 26.1603 2.88016Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { SexToysIcon };
